export default {
    name: 'outputsCancelled',
    component: () => import(/* webpackChunkName: "outputs-cancelled-layout" */ '@/modules/outputs/cancelled/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.outputs.cancelled.index',
            component: () => import(/* webpackChunkName: "outputs-cancelled-index" */ '@/modules/outputs/cancelled/views/Index'),
        },
    ]
}